import React, { useState } from 'react';
import { projects } from '../mockData';
import { MapPin, Calendar, Maximize2 } from 'lucide-react';

const Projects = () => {
  const [filter, setFilter] = useState('Svi');
  
  const categories = ['Svi', 'Stambeno', 'Komercijalno'];
  
  const filteredProjects = filter === 'Svi' 
    ? projects 
    : projects.filter(project => project.category === filter);

  return (
    <section id="projects" className="bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 bg-[#f4e5c3]/30 rounded-full">
            <span className="text-[#b8962e] font-semibold">Naši Projekti</span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-[#0f172a] mb-6 gold-underline">
            Portfolio Izvrsnosti
          </h2>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-12">
            Pogledajte neke od naših najnovijih projekata koji svjedoče o našoj predanosti kvaliteti i preciznosti.
          </p>

          {/* Filter buttons */}
          <div className="flex justify-center gap-4 flex-wrap">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setFilter(category)}
                className={`px-6 py-3 rounded-full font-semibold transition-all ${
                  filter === category
                    ? 'bg-[#d4af37] text-white shadow-lg'
                    : 'bg-white text-gray-700 hover:bg-gray-100 border-2 border-gray-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project) => (
            <div 
              key={project.id} 
              className="project-card group cursor-pointer bg-white"
            >
              <div className="relative h-80 overflow-hidden">
                <img 
                  src={project.image} 
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-80 group-hover:opacity-90 transition-opacity"></div>
                
                <div className="absolute top-4 right-4">
                  <span className="px-4 py-2 bg-[#d4af37] text-white rounded-full text-sm font-semibold">
                    {project.category}
                  </span>
                </div>
                
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <h3 className="text-2xl font-bold mb-3">{project.title}</h3>
                  
                  <div className="flex items-center gap-4 text-sm mb-3">
                    <div className="flex items-center gap-1">
                      <Calendar className="w-4 h-4" />
                      <span>{project.year}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Maximize2 className="w-4 h-4" />
                      <span>{project.area}</span>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="p-6">
                <p className="text-gray-600 leading-relaxed">
                  {project.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {filteredProjects.length === 0 && (
          <div className="text-center py-12">
            <p className="text-xl text-gray-500">Nema projekata u ovoj kategoriji.</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default Projects;